import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import Screenshots from "@/components/Screenshots";
import { Meta } from "@/components/Meta";

export default function ScreenshotsPage() {
  return (
    <BasicScrollView center={true}>
      <Meta title={"Screenshots"} />
      <Screenshots />
      <Footer />
    </BasicScrollView>
  );
}
